import { useQuery } from "react-query";
import axios from "../axios";

const useGetBags = ({ seller_id, search, sort }) => {
  const query = useQuery(
    ["bags", seller_id, search, sort], // <-- include sort and seller_id in the key
    async () => {
      const response = await axios.get(
        `/api/bag-requests/seller?requested_by=${seller_id}&search=${search}&sort=${sort}`
      );
      return response.data;
    },
    {
      enabled: !!seller_id, // only fetch when seller_id exists
    }
  );

  return query;
};

export default useGetBags;
